const lazyload = (function() {
    let observer = null;

    function init() {
        if ('IntersectionObserver' in window) {
            observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const img = entry.target;
                        loadImage(img);
                        observer.unobserve(img);
                    }
                });
            }, {
                rootMargin: '100px',
                threshold: 0.1
            });

            document.querySelectorAll('img[data-src]').forEach(img => {
                observer.observe(img);
            });
        } else {
            document.querySelectorAll('img[data-src]').forEach(img => {
                loadImage(img);
            });
        }
    }

    function loadImage(img) {
        const src = img.getAttribute('data-src');
        if (src) {
            img.src = src;
            img.removeAttribute('data-src');
            
            img.onload = function() {
                img.classList.remove('lazy-loading');
                img.classList.add('lazy-loaded');
            };
        }
    }

    function observeNewImages() {
        if (observer) {
            document.querySelectorAll('img[data-src]').forEach(img => {
                observer.observe(img);
            });
        }
    }

    return {
        init,
        observeNewImages
    };
})();